











import {Component, Prop, Ref, Vue} from 'vue-property-decorator';

type TypoVariant =
	'h1'
	| 'h2'
	| 'h3'
	| 'h4'
	| 'body-perex'
	| 'body-paragraph'
	| 'body-small';

@Component({})
export default class Typo extends Vue {
	@Prop({required: true}) readonly variant: TypoVariant;
	@Prop({default: () => ([])}) readonly classes?: string[];
	@Prop({default: () => ({})}) readonly styles?: CSSStyleDeclaration;
	@Prop({default: null}) readonly element?: string;
	@Prop({default: false}) readonly underline?: boolean;
	@Prop({default: null}) readonly align?: string;

	@Ref('typoRef') readonly typo: HTMLButtonElement;

	availableVariants: string[] = [
		'none',
		'h1',
		'h2',
		'h3',
		'h4',
		'body-perex',
		'body-paragraph',
		'body-small'
	];

	get componentElement(): string {
		if (this.element) {
			return this.element;
		}

		if (this.availableVariants.indexOf(this.variant) < 0) {
			console.error(`Typo: variant '${this.variant}' is not supported. Available variants: \n`, [...this.availableVariants]);

			return 'div';
		}

		switch (this.variant) {
			case 'h1':
			case 'h2':
			case 'h3':
			case 'h4':
				return this.variant;

			case 'body-perex':
			case 'body-paragraph':
			case 'body-small':
				return 'p';

			default:
				return 'div';
		}
	}

	get classList(): Array<string | null> {
		return [
			'typo',
			`typo--${this.variant}`,
			this.align ? `typo--align-${this.align}` : null,
			this.underline ? 'typo--underline' : null,
			...(this.classes || [])
		];
	}

	get styleList(): CSSStyleDeclaration | null {
		return this.styles ? {...this.styles} : null;
	}
}
